import { render, staticRenderFns } from "./ShopifyProductPrice.vue?vue&type=template&id=ef8de2ba&"
import script from "./ShopifyProductPrice.vue?vue&type=script&lang=js&"
export * from "./ShopifyProductPrice.vue?vue&type=script&lang=js&"
import style0 from "./ShopifyProductPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports